export enum LogLevel {
  Debug = 'DEBUG',
  Info = 'INFO',
  Warn = 'WARN',
  Error = 'ERROR',
}

export const LOG_LEVEL_TOKENS: Record<string, LogLevel> = {
  DEBUG: LogLevel.Debug,
  INFO: LogLevel.Info,
  WARN: LogLevel.Warn,
  WARNING: LogLevel.Warn,
  ERROR: LogLevel.Error,
  EXCEPTION: LogLevel.Error,
  FATAL: LogLevel.Error,
  CRITICAL: LogLevel.Error,
};

export const LOG_LEVEL_PALETTE_COLORS: Record<LogLevel, 'primary' | 'success' | 'warning' | 'error'> = {
  [LogLevel.Debug]: 'primary',
  [LogLevel.Info]: 'success',
  [LogLevel.Warn]: 'warning',
  [LogLevel.Error]: 'error',
};

export const LOG_LEVELS = [LogLevel.Debug, LogLevel.Info, LogLevel.Warn, LogLevel.Error];

export const DEFAULT_ENABLED_LOG_LEVELS = [LogLevel.Info, LogLevel.Warn, LogLevel.Error];

const LOG_LEVEL_TOKEN_SOURCE = `\\b(${Object.keys(LOG_LEVEL_TOKENS).join('|')})\\b`;

export const LOG_LEVEL_TOKEN_SPLITTER = new RegExp(LOG_LEVEL_TOKEN_SOURCE, 'g');

const logLevelTokenMatcher = new RegExp(LOG_LEVEL_TOKEN_SOURCE);

export const detectLogLevel = (line: string): LogLevel | null => {
  const match = logLevelTokenMatcher.exec(line);

  return match ? (LOG_LEVEL_TOKENS[match[1]] ?? null) : null;
};

export const isLogLevel = (value: unknown): value is LogLevel => LOG_LEVELS.includes(value as LogLevel);
